import { render, staticRenderFns } from "./CustomerGenQuotationPayments.vue?vue&type=template&id=ad968886"
import script from "./CustomerGenQuotationPayments.vue?vue&type=script&lang=js"
export * from "./CustomerGenQuotationPayments.vue?vue&type=script&lang=js"
import style0 from "./CustomerGenQuotationPayments.vue?vue&type=style&index=0&id=ad968886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports